"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Appointment Experience API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentActivityStatusEnum = void 0;
/**
 * @export
 * @enum {string}
 */
var AppointmentActivityStatusEnum;
(function (AppointmentActivityStatusEnum) {
    AppointmentActivityStatusEnum["Started"] = "started";
    AppointmentActivityStatusEnum["Updated"] = "updated";
    AppointmentActivityStatusEnum["Completed"] = "completed";
})(AppointmentActivityStatusEnum = exports.AppointmentActivityStatusEnum || (exports.AppointmentActivityStatusEnum = {}));
